// General
import React, { Component, useState } from 'react';
import ReactDOM from 'react-dom';

// Bootstrap
import {
    Grid,
    Row,
    Col
} from 'react-bootstrap';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Discount.css';
import bt from '../../components/commonStyle.css';

// Locale
import messages from '../../locale/messages';
import { FormattedMessage } from 'react-intl';

//import FsLightbox from 'fslightbox-react';

//Images
//import GiftImage from '../../../public/SiteImages/gift.svg';


class Discount extends Component {

    /*constructor(props) {
      super(props);
      this.state = {
        investorVideoToggler: false,
      };
    }*/
    
    render() {
        //const { investorVideoToggler } = this.state;

        return (
            <div className={s.bgColor}>
                <Grid fluid className={s.container}>
                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <div className={s.displayTable}>
                                <div className={s.displayTableRow}>
                                    <div className={s.displayTableCell}>
                                    {/* <a className={s.titleText} href="javascript:void(0);" onClick={() => this.setState({ investorVideoToggler: !investorVideoToggler })}>
Investor Video
</a><span className={s.titleText}> · </span><a className={s.titleText} href="/contact">Get in Touch</a> */}
                                        <p className={s.titleText}><FormattedMessage {...messages.discountDescLabel} /></p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Grid>
                {/* <FsLightbox
            toggler={investorVideoToggler}
            sources={['https://www.youtube.com/watch?v=_q9l8Fe8ae8']}
                /> */}
            </div>
        )
    }
}

export default withStyles(s, bt)(Discount);


// WEBPACK FOOTER //
// src/components/Discount/Discount.js